import { render, staticRenderFns } from "./dspLogo.vue?vue&type=template&id=073af08e&"
import script from "./dspLogo.vue?vue&type=script&lang=js&"
export * from "./dspLogo.vue?vue&type=script&lang=js&"
import style0 from "./dspLogo.vue?vue&type=style&index=0&id=073af08e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports